"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { PiCaretDownBold } from "react-icons/pi";

import { cn } from "@/lib/utils";

export function Accordion(props: AccordionPrimitive.AccordionSingleProps | AccordionPrimitive.AccordionMultipleProps) {
  return <AccordionPrimitive.Root {...props} />;
}

export function AccordionItem({ className, ...props }: AccordionPrimitive.AccordionItemProps) {
  return <AccordionPrimitive.Item className={cn("border-b border-black", className)} {...props} />;
}

export function AccordionHeader({ className, children, ...props }: AccordionPrimitive.AccordionHeaderProps) {
  return (
    <AccordionPrimitive.AccordionHeader className={className} {...props}>
      {children}
    </AccordionPrimitive.AccordionHeader>
  );
}

type AccordionTriggerProps = AccordionPrimitive.AccordionTriggerProps & {
  withHeader?: boolean;
};

export function AccordionTrigger({ className, children, withHeader = true, ...props }: AccordionTriggerProps) {
  const trigger = (
    <AccordionPrimitive.Trigger
      className={cn(
        "flex flex-1 items-center justify-between p-4 text-sm font-medium transition-all outline-none focus-visible:outline-primary hover:underline data-[state=open]:underline [&[data-state=open]>svg]:rotate-180",
        className
      )}
      {...props}
    >
      {children}
      <PiCaretDownBold className="h-4 w-4 shrink-0 text-black transition-transform duration-200" />
    </AccordionPrimitive.Trigger>
  );

  if (withHeader) {
    return <AccordionHeader className="flex">{trigger}</AccordionHeader>;
  }

  return trigger;
}

export function AccordionContent({ className, children, ...props }: AccordionPrimitive.AccordionContentProps) {
  return (
    <AccordionPrimitive.Content
      className={cn(
        "text-sm text-gray-600 overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        className
      )}
      {...props}
    >
      <div className={cn("pb-4 pt-0", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}
